import React from "react";
import "./Footer.css";
import {FaFacebookF,
    FaInstagram,
    FaTwitter,
    FaLinkedin,FaLink,FaGithub} from "react-icons/fa"
import { useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate()
  return (
    <div className="footer_main_wrapper">
      <div className="footer_option">
        <span>Terms of Use</span>
        <span>Privacy Policies</span>
        <span onClick={()=>{navigate('/about')}}>About</span>
        <span onClick={()=>{navigate('/#search')}}>Search</span>
      </div>

      

      <div className="social_icons_footer">
        <span className="icon" onClick={()=>{window.open("https://github.com/YashChandrawat")}}>
          <FaGithub />
        </span>
        
        <span className="icon" onClick={()=>{window.open("https://www.instagram.com/yash.chandrawat/")}}>
          <FaInstagram />
        </span>
        <span className="icon" onClick={()=>{window.open("https://www.linkedin.com/in/yash-chandrawat-06b84a219/")}}>
          <FaLinkedin />
        </span>
      </div>


      <div className="footer_text01">Thank you for visiting Yflix - Movie Data Display! We hope you enjoyed exploring our site and discovering new movies.</div>

      <div className="footer_text02">Created By Yash Chandrawat and Vedika Patidar</div>
    </div>
  );
}

export default Footer;
